import React, { useEffect, useState } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const EditResourceDrawer = ({ isOpen, onClose, resource, onSubmit }) => {
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (resource) setTitle(resource.title);
  }, [resource]);

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<h2>Edit Resource</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row">
          <GradientButton onClick={onClose}>Cancel</GradientButton>
          <GradientButton
            onClick={() =>
              onSubmit({ resource_id: resource.resource_id, title })
            }
          >
            Save
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default EditResourceDrawer;